import React from 'react'
import { doc, onSnapshot } from 'firebase/firestore'
import { db } from '../firebase'
import Message from './Message'
import { useAuth } from '../contexts/AuthContext'
import { useChat } from '../contexts/ChatContext'
import { useNav } from '../contexts/NavContext'

const MessageHistory = () => {
   const [messages, setMessages] = React.useState([])
   const { user } = useAuth()
   const { cChat } = useChat()
   const { isNavOpen, toggleNav } = useNav()

   React.useEffect(() => {
      const getMessages = () => {
         return onSnapshot(doc(db, "chats", cChat.chatId), (doc) => {
            doc.exists() && setMessages(doc.data().messages)
         })
      }

      const unsubscribe = cChat.chatId && getMessages()
      return () => {
         unsubscribe?.();
      }
   }, [cChat.chatId])

   return (
      <div className='basis-1 grow p-8 overflow-y-scroll grid gap-5 content-start mb-36 md:m-0' onClick={() => isNavOpen && toggleNav()}>
         {messages.map((message) => (<Message owner={message.senderId === user.uid ? true : false} message={message} key={message.id} />))}
      </div>
   )
}

export default MessageHistory